import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmproject/cecUnmProject/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmproject/cecUnmProject/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmproject/cecUnmProject/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmproject/cecUnmProject/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmproject/cecUnmProject/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmproject/cecUnmProject/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmproject/cecUnmProject/import',
      method: 'post',
      data: data
    })
  }
}
